import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
//import { AppSettings } from "./appsettings";
import { HttpClient } from '@angular/common/http';
import { Appsetting } from '../../app/model/models';
import { environment } from '../../environments/environment';
@Injectable()
export class AppSettingsService {
    constructor(private http: HttpClient) {
    }
    getSettings() {
        let appSettings = require('../../../../appsettings.json');
        environment.appSetting.azureidentityserver = appSettings.MMDWise.AzureTokenURI;
        environment.appSetting.azureapiUrl = appSettings.MMDWise.AzureAPIBasePath;
        environment.appSetting.azurePatientPortalUrl = appSettings.MMDWise.AzurePatientPortalUrl;
        environment.appSetting.identityserver = appSettings.MMDWise.TokenURI;
        environment.appSetting.clientid = appSettings.MMDWise.ClientId;
        environment.appSetting.secretkey = appSettings.MMDWise.ClientSecret;
        environment.appSetting.portalclientid = appSettings.MMDWise.PortalClientId;
        environment.appSetting.portalsecretkey = appSettings.MMDWise.PortalClientSecret;
        environment.appSetting.hashcode = appSettings.MMDWise.HashCode;
        environment.appSetting.apiUrl = appSettings.MMDWise.APIBasePath;
        environment.appSetting.patientPicturesFolderPath = appSettings.MMDWise.PicturePath;
        environment.appSetting.defaultImagePath = '';
        environment.appSetting.instaPractURL = appSettings.MMDWise.IntrospectURI;
        environment.appSetting.connectmmdURL = appSettings.MMDWise.ConnectmmdURL;
        environment.appSetting.requestFrom = appSettings.MMDWise.RequestFrom;
        environment.appSetting.baseUrI = appSettings.MMDWise.BaseURI;
        environment.appSetting.androidAppStore = appSettings.MMDWise.AndroidAppStore;
        environment.appSetting.iphoneAppStore = appSettings.MMDWise.IphoneAppStore;
        environment.appSetting.isProd = appSettings.MMDWise.IsProd;
        environment.appSetting.prodType = appSettings.MMDWise.ProdType;
        environment.appSetting.logoutURL = appSettings.MMDWise.LogoutURL;
        //return this.http.get(reqPath)
        //    .map(this.extractData)
        //    .catch(this.handleErrors);
    }
    //private extractData(res: Response) {
    //    let body = res.json();
    //    return body || {};
    //}
    //private handleErrors(error: any): Observable<any> {
    //    console.error('An error occurred', error);
    //    return Observable.throw(error.message || error);
    //}
} 